import { array, number, object, optional } from "superstruct";

const ProductReviewInfoSchema = object({
    avgRate: number(),
    productId: number(),
    reviewCount: number(),
    starsDistribution: optional(
        array(
            object({
                rating: number(),
                countReview: number(),
            })
        )
    ),
});

export default ProductReviewInfoSchema;
